import { VStack } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { Question, QuestionType } from "../../../gateway/gRPC/pb/surveys_pb";
import { gray_50 } from "../../../theme/theme";
import FormContainer from "../../forms/FormContainer/FormContainer";
import FormInput from "../../forms/FormContainer/FormInput";
import FormTextArea from "../../forms/FormContainer/FormTextArea";
import { SubHeading } from "../../headings/Headings";
import { SubmitHandler } from "react-hook-form";
import QuestionTypeForm from "./QuestionTypeForm";



interface QuestionFormProps {
    onSubmit: SubmitHandler<Question.AsObject>;
    sectionIndex: string;
    questionIndex: string;
    type: QuestionType;
    initialValues?: Question.AsObject;
  }
  
const SurveyQuestionForm = ({
    sectionIndex,
    questionIndex,
    type,
    initialValues,
    onSubmit,
  }: QuestionFormProps) => {
    const [typeData, setTypeData] = useState<any>();
    const [question, setQuestion] = useState<string>("");
    const [description, setDescription] = useState<string>("");
  
    const handleSubmitQuestion = (data: Question.AsObject) => {
      onSubmit(data);
    };
    useEffect(() => {
      if (typeData) {
        const newData: Question.AsObject = {
          index: parseInt(questionIndex),
          sectionId: sectionIndex,
          type: type,
          question: question,
          description: description,
          required: false,
          ...typeData,
        };
        setQuestion(question);
        setDescription(description);
        handleSubmitQuestion(newData);
      }
    }, [typeData]);
  
    return (
      <VStack
        spacing={".5rem"}
        w={"100%"}
        _hover={{ bg: gray_50 }}
        p={".5rem .5rem 50px .5rem"}
        h={"max-content"}
      >
        <FormContainer initialValues={initialValues} noFooter columns={1} onSubmit={handleSubmitQuestion}>
          <SubHeading>{`Question ${questionIndex}`}</SubHeading>
          <FormInput
            name="question"
            placeholder={"Add your Question here"}
            onChange={(e: any) => {
              setQuestion(e.target.value);
            }}
          />
          <FormTextArea
            name="description"
            placeholder={"Add a small description (Max 300 characters)"}
            onChange={(e: any) => {
              setDescription(e.target.value);
            }}
          />
          <QuestionTypeForm type={type} fieldSetter={setTypeData} />
        </FormContainer>
      </VStack>
    );
  };

  export default SurveyQuestionForm;